import { render, staticRenderFns } from "./ModulosModalNuevo.vue?vue&type=template&id=3ecbb860&scoped=true&"
import script from "./ModulosModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ModulosModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ModulosModalNuevo.vue?vue&type=style&index=0&id=3ecbb860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbb860",
  null
  
)

export default component.exports